<template>
  <div>
    <v-container>
      <v-row>
        <div
          class="d-flex justify-space-between mb-6"
          style="width: 100%;"
        >
          <SectionTitle :title="$t('main.enums.sections.bank_infos')" />
        </div>
        <v-col
          cols="12"
          class="mb-1"
        >
          <SmallSectionTitle
            section-number="1"
            :title="$t('main.enums.sections.bank_coords')"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="displayField['account_iban']">
          <LabelledFieldAlt
            :label="$t('main.enums.fields.account_iban')"
            :value="selectedProfile.account_iban"
            :isError="checks.account_iban"
            :isRequired="isRequired['account_iban']"
            color="purple"
          />
        </v-col>
        <v-col
          v-if="displayField['bank_bic']"
          md="6"
        >
          <LabelledFieldAlt
            :label="$t('main.enums.fields.bank_bic')"
            :value="selectedProfile.bank_bic"
            :isError="checks.bank_bic"
            :isRequired="isRequired['bank_bic']"
            color="purple"
          />
        </v-col>
        <v-col
          v-if="displayField['account_holder']"
          cols="12"
        >
          <LabelledFieldAlt
            :label="$t('main.enums.fields.account_holder')"
            :value="selectedProfile.account_holder"
            :isError="checks.account_holder"
            :isRequired="isRequired['account_holder']"
            color="purple"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script type="text/javascript">
  import mixinUi from '@/mixins/utils/ui.js'
  import CommonMixin from '@/mixins/store/CommonMixin.js'
  import { getFieldsByProperty } from '@/utils/person.utils'

  import SmallSectionTitle from '@/components/ui/common/SmallSectionTitle'
  import SectionTitle from '@/components/ui/common/SectionTitle'
  import LabelledFieldAlt from '@/components/ui/common/LabelledFieldAlt'

  import personTabFields from '@/components/RightDrawer/helpers/PersonTab.fields.json'

  export default {
    components: {
      SectionTitle,
      SmallSectionTitle,
      LabelledFieldAlt,
    },
    mixins: [mixinUi, CommonMixin,],
    data() {
      return {
        localFields: personTabFields.bank,
        checks: {},
      }
    },
    computed: {
      displayField() {
        const allFields = this.requiredAttributes.concat(this.optionalAttributes)

        return getFieldsByProperty(allFields, this.localFields)
      },
      isRequired() {
        return getFieldsByProperty(this.requiredAttributes, this.localFields)
      },
    },
    mounted() {
      this.checks = this.selectedProfile.person_controls[0].checks
    },
  }
</script>
